import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import TopInfo from '../../basicElement/TopInfo';
import Filter from './components/Filter';
import Total from './tables/Total';
import MainContent from './components/MainContent';
import MinusContent from './components/MinusContent';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import '../style/home.less';

class TeachingDetail extends Component {
    constructor(props) {
        super(props);
        const { performanceState } = this.props;
        const { params: { date } = {} } = performanceState;
        this.state = {
            searchParams: { date },
            loading: false,
            cur: 'main',
            data: [],
            restData: {},
        };
    }
    
    componentDidMount() {
        const { searchParams: { date } } = this.state;
        date && this.loadData();
    }

    loadData = () => {
        const { performanceState: { params, userId = '' } } = this.props;
        const { searchParams } = this.state;
        const { areaParams = {}, hasCheckedArea,  areaName, ...restParams } = params;

        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryTeacherScoreDetail,  {
            ...restParams,
            ...areaParams,
            ...searchParams,
            userId,
        }).then(res => {
            const { userScore, ...restData } = res;
            this.setState({
                loading: false,
                data: userScore ? [userScore] : [],
                restData,
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    handleSearch = () => {
        this.loadData();
    }

    handleExport = () => {
        const { performanceState: { params, userId = '' } } = this.props;
        const { searchParams } = this.state;
        const { areaParams = {}, hasCheckedArea,  areaName, ...restParams } = params;

        ExportUtil.export({
            ...restParams,
            ...areaParams,
            ...searchParams,
            userId,
            exportType: 'SINGLE_TEACHER_DETAIL' 
        }, null, API_URL.home.exportTeacherScore);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    changeCur = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { performanceState } = this.props;
        const { cur, loading, searchParams, data, restData } = this.state;
        const { maxDate, userCompellation = '', employeeCode = '' } = performanceState;
        const { date } = searchParams;

        if (!date) {
            return <Redirect to="/home" />;
        }
        return (
            <div className="container">
                <div className="full work_flow">
                    <TopInfo title={`带教绩效排行-${userCompellation}[${employeeCode}]`} onClick={() => history.go(-1)} />
                    <Filter
                        maxDate={maxDate}
                        searchParams={searchParams}
                        onSearch={this.handleSearch}
                        onExport={this.handleExport}
                        onChange={this.handleFilterChange}
                    />
                    <Total
                        data={data}
                        searchParams={searchParams}
                        performanceState={performanceState}
                    />
                    <div className="home" style={{ marginTop: 16, borderTop: '1px solid #d1d1d1' }}>
                        <div className="change-btn" style={{ margin: '24px auto', width: 1100 }}>
                            <a className={cur == 'main' && "cur"} onClick={() => this.changeCur('main')}>主要业绩</a>
                            <a className={cur == 'reduce' && "cur"} onClick={() => this.changeCur('reduce')}>减分</a>
                        </div>
                    </div>
                    {
                        cur == 'main' ?
                            <MainContent loading={loading} restData={restData} date={date} />
                        : 
                            <MinusContent loading={loading} restData={restData} />
                    }
                </div>
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    performanceState: state.rankState.params || {},
});

export default connect(mapSateToProps, null)(TeachingDetail);


// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/index.js